module.exports = __webpack_public_path__ + "img/word.caac29e5.png";